module.exports = __webpack_public_path__ + "static/bwvert-f9ad2511b00d4b6e89b720f3bfb0ea97.svg";